var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningIcon = function SvgWarningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.33333 0C3.73096 0 0 3.73096 0 8.33333C0 12.9357 3.73096 16.6667 8.33333 16.6667C12.9357 16.6667 16.6667 12.9357 16.6667 8.33333C16.6667 3.73096 12.9357 0 8.33333 0ZM1.66667 8.33333C1.66667 4.65143 4.65143 1.66667 8.33333 1.66667C9.87394 1.66667 11.2925 2.18925 12.4214 3.06681L3.06681 12.4214C2.18925 11.2925 1.66667 9.87394 1.66667 8.33333ZM4.24533 13.5999C5.37423 14.4774 6.79276 15 8.33333 15C12.0152 15 15 12.0152 15 8.33333C15 6.79276 14.4774 5.37423 13.5999 4.24533L4.24533 13.5999Z",
    fill: "#DF2020"
  })));
};
export { SvgWarningIcon as ReactComponent };
export default __webpack_public_path__ + "assets/04051bba.svg";